import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { translations, LINKS } from '../../data/translations';

const PRINTED_COVER = '/assets/books/nimnys-night-journal.jpg';

const PrintedEditionSection = () => {
  const { t } = useLanguage();

  const trackClick = () => {
    if (window.plausible) {
      window.plausible('Click', { props: { button: 'Nimnys Night Journal - Amazon' } });
    }
  };

  return (
    <section id="night-journal" className="relative py-12 md:py-20" data-testid="night-journal-release">
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl border border-amber-200/15 bg-[#f5ebe0]/[0.06] backdrop-blur-sm shadow-2xl shadow-black/20">
          <div className="grid grid-cols-1 md:grid-cols-[minmax(220px,0.78fr)_1.22fr] items-center gap-0">
            <div className="flex justify-center p-6 md:p-10">
              <div className="w-full max-w-[245px] overflow-hidden rounded-2xl border border-amber-200/20 shadow-2xl shadow-black/40">
                <img
                  src={PRINTED_COVER}
                  alt="Nimny's Night Journal: The Lantern After Lights-Out cover"
                  className="block w-full h-auto"
                  loading="lazy"
                  width="853"
                  height="1280"
                  decoding="async"
                />
              </div>
            </div>

            <div className="px-6 pb-8 text-center md:px-10 md:py-10 md:text-left">
              <span className="inline-flex rounded-full border border-[#c9a87c]/35 bg-[#c9a87c]/10 px-4 py-1.5 font-sans text-xs font-medium uppercase tracking-[0.18em] text-[#d9bd98]">
                {t(translations.printed.badge)}
              </span>
              <h2 className="mt-5 font-sans text-3xl leading-tight text-[#f5ebe0]/95 md:text-5xl">
                Nimny&rsquo;s Night Journal
              </h2>
              <p className="mt-3 font-serif text-lg italic text-amber-200/70 md:text-xl">
                The Lantern After Lights-Out
              </p>
              <p className="mx-auto mt-6 max-w-xl font-serif text-base leading-relaxed text-amber-200/65 md:mx-0 md:text-lg">
                {t(translations.printed.description)}
              </p>
              <div className="mt-7">
                <a
                  href={LINKS.nightJournal}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={trackClick}
                  className="inline-flex items-center gap-2 rounded-xl bg-[#c9a87c] px-6 py-3 font-sans text-sm font-medium text-[#171421] transition-colors hover:bg-[#d4b896]"
                  data-testid="night-journal-amazon-link"
                >
                  {t(translations.printed.button)}
                  <ExternalLink className="h-4 w-4" aria-hidden="true" />
                </a>
              </div>
              <p className="mt-4 font-sans text-xs tracking-wide text-amber-200/40">
                {t(translations.printed.format)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrintedEditionSection;
